import { resolveAppContext } from "./brandConfig";

export type { AppContext } from "./brandConfig";

// Which experience is the user in? Resolved from the brand registry
// (utils/brandConfig): custom domain or path prefix → that brand, else AskSmart.
export function getAppContext() {
  return resolveAppContext();
}
